import { DateTime } from 'luxon'

import { Box, Text } from '@domain-group/suit-theme'

import type { PublicationEditionModel } from '@models/types'

import styles from './styles.module.scss'

const deadlineTypeTitles = {
  booking: 'Booking',
  artwork: 'Artwork',
  editorial: 'Editorial',
  ofi: 'OFI',
}

const orderedDeadlineTypeKeys = [
  'booking',
  'artwork',
  'ofi',
  'editorial',
] as const

type RenderNextDeadlineParams = {
  deadlines: PublicationEditionModel['deadlines'],
}

const renderNextDeadline = (params: RenderNextDeadlineParams) => {
  const { deadlines } = params

  const deadlineKey = deadlines?.next_up ? deadlines.next_up.type : 'booking'
  // @ts-expect-error TS18048
  const deadlineObj = DateTime.fromFormat(deadlines[deadlineKey], 'dd/MM/yyyy HH:mm')
  const inPast = deadlineObj < DateTime.now()

  // Deadlines all passed, just use booking
  return (
    <>
      <Text color={inPast ? 'red' : 'green'} fontWeight="bold" width="54px">
        {/*
         // @ts-expect-error TS7053 */}
        {deadlineTypeTitles[deadlineKey]}
      </Text>
      <Text color="bodyFontLightColor" style={{ textDecoration: inPast ? 'line-through' : undefined }}>
        {deadlineObj.toFormat("ccc dd LLL yyyy 'at' h:mm a")}
      </Text>
    </>
  )
}

interface DeadlinesProps {
  publicationEdition: PublicationEditionModel,
}

const Deadlines = (props: DeadlinesProps) => {
  const {
    publicationEdition: {
      deadlines,
    },
  } = props

  if (!deadlines) return null

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="5px"
      bottom="large"
      className={styles.root}
      fontSize="13px"
      left="calc(320px + 16px)"
      lineHeight="1.5"
      paddingX="15px"
      paddingY="8px"
      position="fixed"
      width="280px"
      zIndex={10}
      style={{ gap: '8px' }}
    >
      {renderNextDeadline({ deadlines })}

      <Box
        backgroundColor="white"
        border="1px solid"
        borderColor="lineColor"
        borderRadius="5px"
        bottom="calc(100% + 5px)"
        className={styles.menu}
        flexDirection="column"
        left="0"
        paddingY="15px"
        paddingX="15px"
        position="absolute"
        right="0"
        style={{ gap: 8 }}
      >
        {orderedDeadlineTypeKeys.map((deadlineTypeKey) => {
          if (deadlines[deadlineTypeKey]){
            const deadlineObj = DateTime.fromFormat(deadlines[deadlineTypeKey], 'dd/MM/yyyy HH:mm')
            const inPast = deadlineObj < DateTime.now()

            return (
              <Box key={deadlineTypeKey} style={{ gap: '8px' }}>
                <Text color={inPast ? 'red' : 'green'} fontWeight="bold" width="54px">
                  {deadlineTypeTitles[deadlineTypeKey]}
                </Text>
                <Text color="bodyFontLightColor" style={{ textDecoration: inPast ? 'line-through' : undefined }}>
                  {deadlineObj.toFormat("ccc dd LLL yyyy 'at' h:mm a")}
                </Text>
              </Box>
            )
          }

          return null
        })}
      </Box>
    </Box>
  )
}

export default Deadlines
